import React from "react";

const TopBarEtrn = () => (
    <svg className="custom-navbar__menu-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="black" strokeWidth="2"/>
        <path d="M8 12.3L10.6 15L16 9.3" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export { TopBarEtrn };
